import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import { reducer as toastrReducer } from "react-redux-toastr";

import { ACTION_TYPES } from "./constants";

import login from "../modules/login/login.reducers";
import orders from "../modules/orders/orders.reducers";
import invalidOrders from "../modules/orders/invalidOrders.reducers";
import tickets from "../modules/tickets/tickets.reducers";
import orderDetails from "../modules/OrderDetails/orderDetails.reducers";
import distributors from "../components/distributors/distributors.reducers";
import callCenter from "../modules/CallCenter/callCenter.reducers";
import users from "../modules/Admin/admin.reducers";
import userDetails from "../modules/UserDetails/userDetails.reducers";
import deliveredOrders from "../modules/DeliveredOrders/deliveredOrders.reducers";
import canceledOrders from "../modules/CanceledOrders/canceledOrders.reducers";
import bookedOrders from "../modules/BookedOrders/bookedOrders.reducers";
import restaurants from "../modules/Restaurant/restaurant.reducers";
import regions from "../modules/Restaurant/restaurant.regions.reducers";
import restaurantDetails from "../modules/RestaurantDetails/restaurantDetails.reducers";
import balanceDetails from "../modules/Balance/balance.reducers";
import giftCards from "../modules/GiftCard/giftCard.reducers";
import quantitativeMovements from "../modules/QuantitativeMovement/quantitativeMovement.reducers";
import b2bUsersReport from "../modules/B2bUsersReport/b2bUsersReport.reducers";
import b2bUsers from "../modules/B2bUsers/b2bUsers.reducers";
import reportDetails from "../modules/Finance/reportDetails.reducers";
import distributorsReports from "../modules/Finance/distributorsReports.reducers";
import printers from "../modules/Printer/printer.reducers";
import salary from "../modules/Salary/salary.reducers";
import tariffDetails from "../modules/Salary/tariff.reducers";
import terminal from "../modules/Terminal/terminal.reducers";
import loading from "../components/loading/loading.reducers";
import distributionPartner from "../components/distributors/distributorPartner.reducers";
import generalSettings from "../modules/SuppliersAutomaticReport/generalSettings.reducers";
import areaDetails from "../modules/Area/area.reducers";
import configs from "../modules/Config/config.reducers";
import dispatch from "../modules/DispatchConfig/dispatch.reducers";
import refund from "../modules/refund/refund.reducers";
import deliveryPriceReport from "../modules/DeliveryPriceReport/deliveryPriceReport.reducers";
import hdmReport from "../modules/HdmPrintReport/HdmPrintReport.reducers";
import deedReport from "../modules/DeedReport/DeedReport.reducers";
import settingDeliveryService from "../modules/SettingDeliveryService/SettingDeliveryService.reducers";
import newDistributors from "../modules/Admin/newDistributor.reducer";
import allPartners from "../modules/Admin/partners.reducer";

const appReducer = combineReducers({
    login,
    orders,
    invalidOrders,
    tickets,
    distributors,
    orderDetails,
    callCenter,
    i18n: i18nReducer,
    toastr: toastrReducer,
    users,
    userDetails,
    deliveredOrders,
    canceledOrders,
    bookedOrders,
    restaurants,
    regions,
    restaurantDetails,
    balanceDetails,
    giftCards,
    quantitativeMovements,
    b2bUsersReport,
    b2bUsers,
    reportDetails,
    distributorsReports,
    printers,
    salary,
    tariffDetails,
    terminal,
    loading,
    distributionPartner,
    generalSettings,
    areaDetails,
    configs,
    dispatch,
    refund,
    deliveryPriceReport,
    hdmReport,
    deedReport,
    settingDeliveryService,
    newDistributors,
    allPartners
});

const rootReducer = (state, action) => {
    if (action.type === ACTION_TYPES.LOGOUT_SUCCESS) {
        const { i18n } = state;

        state = { i18n };
    }

    return appReducer(state, action);
};

export default rootReducer;
